import { Action, ThunkAction, combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { api } from 'api/api';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
import AppReducer from 'shared/reducers/appSlice';
import UsersTableReducer from 'shared/reducers/usersTableSlice';
import UserStatsReducer from 'shared/reducers/userStatsSlice';
import loggerMiddleware from 'utils/logger-middleware';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});
export const store = configureStore({
  devTools: process.env.NODE_ENV === 'development' ? true : false,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat([api.middleware, routerMiddleware, loggerMiddleware]),
  reducer: combineReducers({
    router: routerReducer,
    app: AppReducer,
    usersTable: UsersTableReducer,
    userStats: UserStatsReducer,
    [api.reducerPath]: api.reducer,
  }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

setupListeners(store.dispatch);
export const history = createReduxHistory(store);
